module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_vm._l((_vm.fieldList), function(field) {
    return _c('div', {
      class: ("form-group field-" + (field.name.replace('_', '-')))
    }, [_c('label', [_vm._v(_vm._s(field.title))]), _vm._v(" "), (field.type == 'school') ? _c('multi-select', {
      attrs: {
        "disabled": field.disabled,
        "label": _vm.schoolLabel,
        "filter": _vm.schoolFilter,
        "placeholder": "Wähle ein Schule aus",
        "url": "schools"
      },
      on: {
        "input": function (val) {
          _vm.onInput(field.name, val)
        }
      },
      model: {
        value: (_vm.value[field.name]),
        callback: function($$v) {
          _vm.$set(_vm.value, field.name, $$v)
        },
        expression: "value[field.name]"
      }
    }, [_c('span', {
      attrs: {
        "slot": "noResult"
      },
      slot: "noResult"
    }, [_vm._v("\n                Keine Schulen gefunden\n            ")])]) : (field.type == 'city') ? _c('city-select', {
      attrs: {
        "disabled": field.disabled
      },
      on: {
        "input": function (val) {
          _vm.onInput(field.name, val)
        }
      },
      model: {
        value: (_vm.value[field.name]),
        callback: function($$v) {
          _vm.$set(_vm.value, field.name, $$v)
        },
        expression: "value[field.name]"
      }
    }) : (field.type == 'select') ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.value[field.name]),
        expression: "value[field.name]"
      }],
      class: {
        'form-control': 1, 'is-invalid': _vm.errors[field.name]
      },
      attrs: {
        "disabled": field.disabled
      },
      on: {
        "input": function (val) {
          _vm.onInput(field.name, val)
        },
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.value, field.name, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((field.options), function(value, key) {
      return _c('option', {
        domProps: {
          "value": key
        }
      }, [_vm._v("\n                " + _vm._s(value) + "\n            ")])
    })) : (field.type == 'user') ? _c('user-select', {
      attrs: {
        "disabled": field.disabled,
        "placeholder": field.placeholder,
        "type": field.userType,
        "multiple": field.multiple
      },
      on: {
        "input": function (val) {
          _vm.onInput(field.name, val)
        }
      },
      model: {
        value: (_vm.value[field.name]),
        callback: function($$v) {
          _vm.$set(_vm.value, field.name, $$v)
        },
        expression: "value[field.name]"
      }
    }) : (field.type == 'toggle') ? _c('toggle', {
      attrs: {
        "disabled": field.disabled,
        "choices": field.choices
      },
      on: {
        "input": function (val) {
          _vm.onInput(field.name, val)
        }
      },
      model: {
        value: (_vm.value[field.name]),
        callback: function($$v) {
          _vm.$set(_vm.value, field.name, $$v)
        },
        expression: "value[field.name]"
      }
    }) : (field.type == 'photos') ? _c('photo-upload', {
      attrs: {
        "disabled": field.disabled,
        "mutiple": ""
      },
      on: {
        "input": function (val) {
          _vm.onInput(field.name, val)
        }
      },
      model: {
        value: (_vm.value[field.name]),
        callback: function($$v) {
          _vm.$set(_vm.value, field.name, $$v)
        },
        expression: "value[field.name]"
      }
    }) : (field.type == 'number') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.value[field.name]),
        expression: "value[field.name]"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "inputmode": "numeric",
        "pattern": "[0-9]*",
        "disabled": field.disabled,
        "min": field.min
      },
      domProps: {
        "value": (_vm.value[field.name])
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.value, field.name, $event.target.value)
        }, function($event) {
          _vm.onInput(field.name, $event.target.value)
        }]
      }
    }) : (field.type == 'textarea') ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.value[field.name]),
        expression: "value[field.name]"
      }],
      domProps: {
        "value": (_vm.value[field.name])
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.value, field.name, $event.target.value)
        }, function($event) {
          _vm.onInput(field.name, $event.target.value)
        }]
      }
    }) : ((field.type) === 'checkbox') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.value[field.name]),
        expression: "value[field.name]"
      }],
      class: {
        'form-control': 1, 'is-invalid': _vm.errors[field.name]
      },
      attrs: {
        "disabled": field.disabled,
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(_vm.value[field.name]) ? _vm._i(_vm.value[field.name], null) > -1 : (_vm.value[field.name])
      },
      on: {
        "input": function($event) {
          _vm.onInput(field.name, $event.target.value)
        },
        "change": function($event) {
          var $$a = _vm.value[field.name],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.value[field.name] = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.value[field.name] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.$set(_vm.value, field.name, $$c)
          }
        }
      }
    }) : ((field.type) === 'radio') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.value[field.name]),
        expression: "value[field.name]"
      }],
      class: {
        'form-control': 1, 'is-invalid': _vm.errors[field.name]
      },
      attrs: {
        "disabled": field.disabled,
        "type": "radio"
      },
      domProps: {
        "checked": _vm._q(_vm.value[field.name], null)
      },
      on: {
        "input": function($event) {
          _vm.onInput(field.name, $event.target.value)
        },
        "change": function($event) {
          _vm.$set(_vm.value, field.name, null)
        }
      }
    }) : _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.value[field.name]),
        expression: "value[field.name]"
      }],
      class: {
        'form-control': 1, 'is-invalid': _vm.errors[field.name]
      },
      attrs: {
        "disabled": field.disabled,
        "type": field.type
      },
      domProps: {
        "value": (_vm.value[field.name])
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.value, field.name, $event.target.value)
        }, function($event) {
          _vm.onInput(field.name, $event.target.value)
        }]
      }
    }), _vm._v(" "), (_vm.errors[field.name]) ? _c('div', {
      staticClass: "invalid-feedback"
    }, [_vm._v("\n            " + _vm._s(_vm.errors[field.name][0]) + "\n        ")]) : _vm._e()], 1)
  }), _vm._v(" "), _c('input', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "disabled": _vm.submitting
    },
    domProps: {
      "value": _vm.submitLabel
    }
  }), _vm._v(" "), (_vm.secondaryLabel) ? _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.secondaryAction($event)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.secondaryLabel) + "\n    ")]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-670e0f0c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/custom-form.vue
// module id = 104
// module chunks = 0 1